<div class="chip" [class]="_status().color" *ngIf="status" [matTooltipDisabled]="!_status().isUnknown"
  [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="_status().status">
  {{'TRADEMARK.STATUS_'+(_status().isUnknown ? 'UNKNOWN' : _status().status).replace(' ','_') | translate}}
</div>